// extracted by mini-css-extract-plugin
export default {"icon":"super-speed-icon__icon___jFH8H","popper":"super-speed-icon__popper___wq0An","tooltip":"super-speed-icon__tooltip___yHEK0"};